import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../api'

const logout = async () => {
  const { error } = await supabase.auth.signOut()

  if (error) {
    throw error
  }
}

export default function useLogOut(navigate?: (payload: any) => void) {
  const queryClient = useQueryClient()

  return useMutation(() => logout(), {
    onSuccess: () => {
      queryClient.setQueryData(['isAuth'], { isAuth: false })
      queryClient.setQueryData(['user'], null)
      queryClient.setQueryData(['profile'], null)
      queryClient.setQueryData(['user-categories'], null)
      queryClient.invalidateQueries({ queryKey: ['useGetRecentQuerySuggestion'] })
      if (navigate) navigate('/')
    },
  })
}
